import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  ColumnsPanelTrigger,
  GridToolbarFilterButton,
  Toolbar,
  GridToolbarProps,
} from '@mui/x-data-grid';
import { Tooltip } from '@material-ui/core';
import {
  SortButton,
  IconButtonWrapper,
  ToolbarBox,
} from './UserRequestsStyles';
import ListIcon from '@material-ui/icons/ViewList';
import pluralize from 'pluralize';

export type UserRequestsToolbarProps = {
  total: number;
  label: string;
  actions?: React.ReactNode;
} & GridToolbarProps;

export const UserRequestsToolbar = ({
  total,
  label,
  actions,
}: UserRequestsToolbarProps) => {
  return (
    <Toolbar>
      <ToolbarBox>
        <Typography variant="h6">{`${total} ${pluralize(
          label,
          total,
        )}`}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: 16 }}>
          {actions}
          <Tooltip title="Columns">
            <ColumnsPanelTrigger
              render={
                <IconButtonWrapper>
                  <SortButton color="primary">
                    <ListIcon />
                  </SortButton>
                </IconButtonWrapper>
              }
            />
          </Tooltip>
          <GridToolbarFilterButton />
        </Box>
      </ToolbarBox>
    </Toolbar>
  );
};

export default UserRequestsToolbar;
